import NoteRepositoryInterface, {
  ChatNoteInterface,
  NoteInterface,
  TicketNoteInterface,
} from '@/services/QA/note/interfaces';
import { AxiosInstance } from 'axios';

export default class NoteRepository implements NoteRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async addChatNote(
    chatId: string,
    noteData: Partial<NoteInterface>,
    notifyUsers: boolean = false,
  ): Promise<ChatNoteInterface> {
    const res = await this.axios.post(`/qa-controller/chat/${chatId}/notes`, { noteData, notifyUsers });

    return res.data;
  }

  public async addTicketNote(
    ticketId: number,
    noteData: Partial<NoteInterface>,
    notifyUsers?: boolean,
  ): Promise<TicketNoteInterface> {
    const res = await this.axios.post(`/qa-controller/ticket/${ticketId}/notes`, { noteData, notifyUsers });

    return res.data;
  }

  public async deleteNote(noteId: number): Promise<void> {
    await this.axios.delete(`/qa-controller/notes/${noteId}`);
  }

  public async editNote(noteId: number, content: string, notifyUsers: boolean): Promise<void> {
    await this.axios.patch(`/qa-controller/notes/${noteId}`, { content, notifyUsers });
  }
}
